import PropTypes from 'prop-types'
import { ListItemContainerBottom } from '../../styled-components'

import {
  listItemStateVariantOptions,
  listItemListViewVariantOptions
} from '../../constants'

import ProgressBarComponent from '../../../../atoms/progress-bar'
import {
  progressBarColorOptions,
  progressBarSizeOptions,
  progressBarVariantOptions
} from '../../../../atoms/progress-bar/constants'

import { IsLoading } from '../list-items-item'

const CenterContainerProgressBar = ({
  progressBarControl,
  listViewType,
  state
}) => {
  const { label, value, variant, cancelButton, onChange } =
    progressBarControl || {}

  if (!progressBarControl || value < 0) return null

  const defineVariant =
    state === listItemStateVariantOptions.ERROR
      ? progressBarColorOptions[progressBarVariantOptions.ERROR]
      : variant

  return (
    <ListItemContainerBottom listViewVariant={listViewType}>
      <IsLoading skeletonStyle={{ width: '100%', height: '18px' }}>
        <ProgressBarComponent.Root
          progressBarValue={value}
          isLoading={state === listItemStateVariantOptions.INACTIVE}
          cancelButton={cancelButton}
          onChange={onChange}
        >
          <ProgressBarComponent.Header>
            <ProgressBarComponent.Label
              variant={defineVariant}
              size={progressBarSizeOptions.SMALL}
            >
              {label}
            </ProgressBarComponent.Label>
            <ProgressBarComponent.Label
              variant={defineVariant}
              size={progressBarSizeOptions.SMALL}
            >
              {value}%
            </ProgressBarComponent.Label>
          </ProgressBarComponent.Header>

          <ProgressBarComponent.Bar
            progressBarValue={value}
            variant={defineVariant}
            size={progressBarSizeOptions.SMALL}
          />
        </ProgressBarComponent.Root>
      </IsLoading>
    </ListItemContainerBottom>
  )
}

CenterContainerProgressBar.propTypes = {
  state: PropTypes.oneOf(Object.values(listItemStateVariantOptions)),
  progressBarControl: PropTypes.shape({
    number: PropTypes.number,
    variant: PropTypes.oneOf(Object.values(progressBarVariantOptions)),
    loading: PropTypes.bool,
    cancelButton: PropTypes.bool,
    onChange: PropTypes.func
  }),
  listViewType: PropTypes.oneOf(Object.values(listItemListViewVariantOptions))
}

export default CenterContainerProgressBar
